//@utilities
const { PAGE_GENERIC } = require("utilities/tagging");

export const analyticsId = {
    CLICK_RIGHTS_AND_DATA_PROTECTION_LINK:
        "CLICK_RIGHTS_AND_DATA_PROTECTION_LINK",
    CANCEL_BUTTON: "CANCEL_BUTTON",
    CLICK_BREADCRUMB_01: "CLICK_BREADCRUMB_01",
    CLICK_TOOLTIP_TAE: "CLICK_TOOLTIP_TAE",
    CLICK_TOOLTIP_TOTAL_AMOUNT: "CLICK_TOOLTIP_TOTAL_AMOUNT",
    CLICK_TOOLTIP_VEDACON_CONSENTS: "CLICK_TOOLTIP_VEDACON_CONSENTS",
    CONTINUE_BUTTON: "CONTINUE_BUTTON",
    DISPLAY_DOC: "DISPLAY_DOC",
    ERROR_VIEW: "ERROR_VIEW",
    EXIT_MODAL: "EXIT_MODAL",
    NAVIGATION_RETURN_TO_GP: "NAVIGATION_RETURN_TO_GP",
    OPEN_MODAL: "OPEN_MODAL",
    SUCCESS_VIEW: "SUCCESS_VIEW",
    VEDACON_DOCUMENT_MODAL_VIEW: "VEDACON_DOCUMENT_MODAL_VIEW",
};

const commonFields = () => ({
    categoriaEvento: window.utag_last_name,
});

const commonFieldsTooltip = () => ({
    categoriaEvento: window.utag_last_name,
    accionEvento: "tooltip",
});

export const catalogue = {
    [analyticsId.CLICK_RIGHTS_AND_DATA_PROTECTION_LINK]: () => ({
        ...commonFields(),
        accionEvento: "derechos y proteccion de datos",
    }),
    [analyticsId.CLICK_TOOLTIP_TAE]: () => ({
        ...commonFieldsTooltip(),
        etiquetaEvento: "infoTaeTooltip",
    }),
    [analyticsId.CLICK_TOOLTIP_TOTAL_AMOUNT]: () => ({
        ...commonFieldsTooltip(),
        etiquetaEvento: "infoTotalAmountTooltip",
    }),
    [analyticsId.DISPLAY_DOC]: () => ({
        pathForTag:
            "/prestamos-hipotecas/contratacion-prestamo-ares/autorizacion-consulta-datos-tgss/",
        pageType: PAGE_GENERIC,
        procType: "prestamos-hipotecas",
        processDetails:
            "contratacion-prestamo-ares/autorizacion-consulta-datos-tgss",
    }),
    [analyticsId.OPEN_MODAL]: () => ({
        ...commonFieldsTooltip(),
        accionEvento: "abrir",
    }),
    [analyticsId.EXIT_MODAL]: () => ({
        ...commonFieldsTooltip(),
        accionEvento: "salir",
    }),
    [analyticsId.CANCEL_BUTTON]: () => ({
        ...commonFieldsTooltip(),
        etiquetaEvento: "cancelar",
    }),
    [analyticsId.CONTINUE_BUTTON]: () => ({
        ...commonFieldsTooltip(),
        accionEvento: "continuar",
    }),
    [analyticsId.CLICK_TOOLTIP_VEDACON_CONSENTS]: () => ({
        ...commonFieldsTooltip(),
        eventLabel: "weWantYouEnjoyTooltip",
    }),
    [analyticsId.CLICK_BREADCRUMB_01]: () => ({
        ...commonFields(),
        accionEvento: "préstamos e hipotecas",
        etiquetaEvento: "breadcrumb01",
    }),
    [analyticsId.NAVIGATION_RETURN_TO_GP]: () => ({
        ...commonFieldsTooltip(),
        accionEvento: "volver a posición global",
    }),
    [analyticsId.SUCCESS_VIEW]: () => ({
        pathForTag: "contratacion-prestamo-ares/exito/",
        pageType: PAGE_GENERIC,
        procType: "prestamos-hipotecas",
        processDetails:
            "contratacion-prestamo-ares/autorizacion-consulta-datos-tgss",
    }),
    [analyticsId.ERROR_VIEW]: (descriptionError) => ({
        pathForTag: "contratacion-prestamo-ares/error/",
        pageType: PAGE_GENERIC,
        procType: "Contratación-préstamo-ares",
        procStep: "error",
        descriptionError: descriptionError || "Connection error",
        categoryError: "technical-error",
    }),
    [analyticsId.VEDACON_DOCUMENT_MODAL_VIEW]: () => ({
        pathForTag:
            "/prestamos-hipotecas/contratacion-prestamo-ares/autorizacion-consulta-datos-tgss/",
        pageType: PAGE_GENERIC,
        procType: "prestamos-hipotecas",
        processDetails:
            "contratacion-prestamo-ares/autorizacion-consulta-datos-tgss",
    }),
};
